import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * Az OS Linux?
 * @param ua - UserAgent.
 */
export default function isLinux (ua: string): boolean {
  return userAgentParser.isLinux(ua)
}
